export enum BillingTransportTypeEnum {
    VISIT = '06',
    MONTH = '08',
    DISTANCE = '10',
    NONE = 'none',
}

export const billingTransportTypes = [
    { name: BillingTransportTypeEnum.VISIT },
    { name: BillingTransportTypeEnum.MONTH },
    { name: BillingTransportTypeEnum.DISTANCE },
    { name: BillingTransportTypeEnum.NONE },
]
